import apiService from "./api";
import { sanitizeQueryParams } from "@src/utility/helpers/apiHelper";

export interface FAQ {
  id: string | number;
  question: string;
  answer: string;
  displayOrder: number;
  status: string;
}

export interface AddFAQ {
  question: string;
  answer: string;
  displayOrder?: number;
  status?: string;
}

export interface GetFAQsParams {
  page?: number;
  pageSize?: number;
  question?: string;
  status?: string;
  orderBy?: string;
  orderDirection?: string;
  [key: string]: unknown;
}

export class FAQService {
  async getFAQs(query?: GetFAQsParams) {
    return apiService.get("/faqs", {
      params: sanitizeQueryParams(query || {}),
    });
  }

  async getAllFAQs(
    query?: Pick<GetFAQsParams, "question" | "orderBy" | "orderDirection">
  ) {
    return apiService.get("/faqs/all", {
      params: sanitizeQueryParams(query || {}),
    });
  }

  async getFAQDetails(id: string | number) {
    return apiService.get(`/faqs/${id}`);
  }

  async getNextDisplayOrder() {
    return apiService.get("/faqs/next-display-order");
  }

  async addFAQ(data: AddFAQ) {
    return apiService.post("/faqs", data);
  }

  async updateFAQ(id: string | number, data: Partial<AddFAQ>) {
    return apiService.put(`/faqs/${id}`, data);
  }

  async deleteFAQ(id: string | number) {
    return apiService.delete(`/faqs/${id}`);
  }
}

export const faqService = new FAQService();
